import { useEffect } from 'react';

export const RAIL_OPEN_CLASS = 'ai-assistant-rail-open';

const PREVIEW_DISPLAY_KEY = 'previewDisplay';

export function useRailLayout(open: boolean) {
  useEffect(() => {
    document.body.classList.toggle(RAIL_OPEN_CLASS, open);

    if (open) {
      window.slideCloseOverlay?.();
      try {
        window.sessionStorage.removeItem(PREVIEW_DISPLAY_KEY);
      } catch {
        // Nothing to forget.
      }
    }
  }, [open]);

  useEffect(() => () => document.body.classList.remove(RAIL_OPEN_CLASS), []);
}
